    import Vue from 'vue'
import VueRouter from 'vue-router'
import ArtifactsList from "../views/ArchivesList";
import AssetTypeList from "../views/AssetTypeList";
import AssetTagList from "../views/AssetTagList";
import ArtifactAssetList from "../views/ArtifactList";
import AssetsDownloadList from "../views/AssetsDownloadList";
import AssetNonCommercialDownload from "../views/AssetNonCommercialDownload";
import AssetDownloadForm from "../views/AssetDownloadForm";
import ArtifactDetail from "../views/AssetDetail";
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'ArtifactsList',
        component: ArtifactsList,
    },
    {
        path: '/download',
        name: 'AssetsDownloadList',
        component: AssetsDownloadList,
    },
    {
        path: '/asset/:id',
        name: 'ArtifactDetail',
        component: ArtifactDetail,
    },
    {
        path: '/asset-type/:type',
        name: 'AssetTypeList',
        component: AssetTypeList,
    },
    {
        path: '/tags/:slug',
        name: 'AssetTagList',
        component: AssetTagList,
    },
    {
        path: '/non-commercial-download',
        name: 'AssetNonCommercialDownload',
        component: AssetNonCommercialDownload,
    },
    {
        path: '/form',
        name: 'AssetDownloadForm',
        component: AssetDownloadForm,
    },
    {
        path: '/artifact',
        name: 'ArtifactAssetList',
        component: ArtifactAssetList,
        props: true
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
